const gfAjax = (scrollTrigger) => {
	
	var $forms = $('.form__block');

	if($forms.length) {
		
		$forms.each(function() {
			
			const contactForm = $(this),
						gfItem = contactForm.find('.gfid'),
						gfNum = gfItem.attr('data-id'),
						gfId = parseInt(gfNum),
						gfTitle = gfItem.attr('data-title'),
						gfDesc = gfItem.attr('data-descr'),
						gfAjax = gfItem.attr('data-ajax');

			$.ajax({
				type: "GET",
				url: ajax.url,
				data: {
					action: 'load_gravity_form',
					formid: gfId,
					formtitle: gfTitle,
					formdescr: gfDesc,
					formajax: gfAjax,
				}
			}).done(function (data) {

				contactForm.html(data);
				
				const labelText = contactForm.find('label');

				if (labelText) {
					labelText.html(function(_, html) {
						return html.replace('(check all that apply)', '<span class="instruction-text">(check all that apply)</span>');
					});
				}
				
				// Update ScrollTrigger after the contact form loads
				setTimeout(() => {
					scrollTrigger.refresh();
				}, 800);

			});
			
		});

	}
	
}

export {
	gfAjax
}